var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLivestream = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon / Events / Livestream")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Events-/-Livestream",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#383E41",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-6",
    fill: "#0084F8",
    points: "18.0645161 12.4795575 21.6774194 10.3870968 21.6774194 17.6129032 18.0645161 15.2762232"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#383E41",
    strokeWidth: 2,
    fill: "#0084F8",
    x: 7.67741935,
    y: 8.58064516,
    width: 10.8387097,
    height: 10.8387097,
    rx: 3
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLivestream, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Livestream.818d5367.svg";
export { ForwardRef as ReactComponent };